export const WHATSAPP_URL =
    "https://wa.me/34614039737?text=" +
    encodeURIComponent("Hola, me interesan vuestros servicios");

export const EMAIL = "as.studio.24.ct@gmail.com";
export const PHONE_DISPLAY = "+34 614 03 97 37";

export const SERVICES = [
    {
        id: "grabacion",
        num: "01",
        name: "Grabación de vídeo",
        tagline: "Rodaje profesional en Alicante y alrededores",
        meta: ["1 revisión incluida", "Entrega máx. 7 días"],
        tiers: [
            { label: "1 hora", price: "59€" },
            { label: "2 horas", price: "109€" },
            { label: "3 horas", price: "189€" },
            { label: "4 horas", price: "249€" },
        ],
        extras: [],
    },
    {
        id: "fotografia",
        num: "02",
        name: "Fotografía",
        tagline: "Imágenes que venden tu marca",
        meta: ["1 revisión incluida", "Entrega máx. 7 días"],
        tiers: [
            { label: "15–20 fotos", price: "29€" },
            { label: "25–30 fotos", price: "49€" },
            { label: "35–40 fotos", price: "69€" },
            { label: "45–50 fotos", price: "89€" },
        ],
        extras: ["Foto extra — 8–15€", "Revisión extra — 19€"],
    },
    {
        id: "edicion",
        num: "03",
        name: "Edición de vídeo",
        tagline: "Del material bruto al vídeo que engancha",
        meta: ["2 revisiones incluidas", "Entrega máx. 7 días"],
        groups: [
            {
                name: "Edición media",
                note: "Edición, texto, color…",
                tiers: [
                    { label: "15–60 s", price: "15€" },
                    { label: "1–3 min", price: "29€" },
                    { label: "3–6 min", price: "49€" },
                    { label: "6–10 min", price: "69€" },
                ],
            },
            {
                name: "Edición avanzada",
                note: "Motion graphics…",
                tiers: [
                    { label: "15–60 s", price: "39€" },
                    { label: "1–3 min", price: "69€" },
                    { label: "3–6 min", price: "99€" },
                    { label: "6–10 min", price: "139€" },
                ],
            },
        ],
        extras: ["Entrega rápida — +30–50%", "Revisión extra — 19€"],
    },
    {
        id: "redes",
        num: "04",
        name: "Gestión de redes sociales",
        tagline: "Tu marca creciendo cada semana",
        meta: ["Entrega del calendario en 48–72 h", "Con permanencia (12 meses): primer mes al 10%"],
        tiers: [
            {
                label: "Presencia",
                price: "249€/mes",
                featured: false,
                meta: "1 revisión de calendario",
                features: [
                    "1 red social",
                    "3 publicaciones / semana",
                    "Contenido con tu material",
                    "Plantillas básicas y textos básicos",
                    "Solo publicación",
                ],
            },
            {
                label: "Crecimiento",
                price: "449€/mes",
                featured: true,
                meta: "1 revisión de calendario",
                features: [
                    "2 redes sociales",
                    "5 publicaciones / semana",
                    "Diseño personalizado",
                    "Tu material + 1 foto o vídeo nuestro incluido",
                    "Textos estratégicos",
                    "2–3 stories / semana",
                    "Respuesta de comentarios",
                    "Informe mensual básico",
                    "Reunión estratégica mensual",
                ],
            },
            {
                label: "Full Management",
                price: "949€/mes",
                featured: false,
                meta: "2 revisiones de calendario",
                features: [
                    "3 redes sociales",
                    "7 publicaciones / semana",
                    "Diseño personalizado y branding",
                    "Creación propia + del cliente",
                    "Guiones incluidos",
                    "Stories cada día",
                    "Comentarios y mensajes",
                    "Informe mensual completo",
                    "Reunión estratégica cada 15 días",
                    "Anuncios en TikTok e Instagram",
                    "Resultados garantizados",
                ],
            },
        ],
        extras: ["Contenido fuera del calendario — 15–30€ por pieza"],
    },
    {
        id: "web",
        num: "05",
        name: "Sitios web",
        tagline: "Webs rápidas, bonitas y que convierten",
        meta: ["Entrega máx. 7 días"],
        tiers: [
            {
                label: "Landing",
                price: "199€",
                featured: false,
                meta: "1 revisión",
                features: [
                    "1 página",
                    "Plantilla adaptada a tu marca",
                    "Tú nos das el guión",
                ],
            },
            {
                label: "Web corporativa",
                price: "499€",
                featured: true,
                meta: "2 revisiones",
                features: [
                    "4–6 páginas",
                    "Diseño personalizado",
                    "Redacción de guiones",
                    "SEO incluido",
                    "Formulario de contacto",
                    "3 meses de mantenimiento incluidos",
                ],
            },
            {
                label: "Web + Reservas",
                price: "999€",
                featured: false,
                meta: "2 revisiones",
                features: [
                    "6–10 páginas",
                    "Diseño personalizado",
                    "Redacción de guiones",
                    "Formulario de contacto",
                    "Reserva online",
                    "Tienda online (opcional)",
                    "6 meses de mantenimiento incluidos",
                ],
            },
        ],
        extras: ["Mantenimiento mensual — 30–60€/mes"],
    },
    {
        id: "guiones",
        num: "06",
        name: "Guiones e ideas",
        tagline: "La base de un vídeo que funciona",
        meta: ["1 revisión incluida", "Entrega máx. 7 días"],
        tiers: [
            {
                label: "Idea",
                price: "10–15€",
                sub: "4 ideas — 35–50€",
                features: ["Ideas para tus contenidos"],
            },
            {
                label: "Guion básico",
                price: "20–30€",
                sub: "4 guiones — 70–100€",
                features: ["Ideas + estructura"],
            },
            {
                label: "Guion completo",
                price: "35–50€",
                sub: "4 guiones — 120–170€",
                features: [
                    "Guion perfecto",
                    "Todas las instrucciones",
                    "Indicaciones de plano",
                ],
            },
        ],
        extras: [],
    },
];

export const REVISION_NOTE =
    "En las revisiones entran reencuadres, orden, color, música y texto. No entra grabar otra vez.";
